import { Router } from 'vue-router'
import { isStaleDeployError } from '@/modules/common/utils/staleDeployErrors'
import { RemoteLog } from '@/modules/common/utils/loggingUtils'

const RELOAD_ATTEMPTED_KEY = 'stale-deploy-reload-attempted'

export function registerStaleDeployReload(router: Router): void {
	router.onError((error, to) => {
		if (!isStaleDeployError(error)) {
			return
		}

		// Kept in sessionStorage rather than a local: the reload below wipes module state, and a
		// fresh index.html that still can't load the chunk must fail visibly instead of looping.
		if (sessionStorage.getItem(RELOAD_ATTEMPTED_KEY)) {
			// Sentry ignores these errors, so this line is the only trace of a client stuck on them.
			RemoteLog.error({ message: 'Stale deploy error persisted after reload' })
			return
		}

		sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, 'true')

		RemoteLog.info({ message: 'Stale deploy reloaded' })
		RemoteLog.flush()

		window.location.assign(to.fullPath)
	})

	router.afterEach(() => sessionStorage.removeItem(RELOAD_ATTEMPTED_KEY))
}
